var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMirrorColour = function SvgSocialMirrorColour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "SocialMirrorColour_svg___1sjywpl0 SocialMirrorColour_svg___1sjywpl1 SocialMirrorColour_svg__bc5nciic SocialMirrorColour_svg__bc5nci19f SocialMirrorColour_svg__bc5nci4jw",
    viewBox: "0 0 144 185"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SocialMirrorColour_svg__a)",
    d: "M0 71.613C0 32.063 32.062 0 71.613 0s71.613 32.062 71.613 71.613v102.505c0 6.01-4.872 10.882-10.883 10.882H10.883C4.872 185 0 180.128 0 174.118z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    fillRule: "evenodd",
    d: "M134.717 176.111V71.821c0-34.953-28.252-63.288-63.104-63.288S8.508 36.868 8.508 71.822V176.11c0 .197.16.356.355.356h125.5a.354.354 0 0 0 .354-.356M71.613 0C32.063 0 0 32.156 0 71.822V176.11C0 181.02 3.968 185 8.863 185h125.5c4.895 0 8.863-3.98 8.863-8.889V71.821C143.226 32.157 111.164 0 71.613 0",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SocialMirrorColour_svg__a",
    x1: 18.435,
    x2: 143.747,
    y1: 10.667,
    y2: 209.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#007AFF"
  })))));
};
export default SvgSocialMirrorColour;